import { subscribeFragment } from 'shared_models/forms/fragments/subscribe';

export const RegisterFormModel = {
  settings: {
    hideRequiredMark: true,
    layout: 'inline',
  },
  fields: [
    {
      tag: 'input',
      type: 'text',
      name: 'firstName',
      validateTrigger: 'onBlur',
      rules: [
        {
          pattern: "^[a-zA-ZÀÁÂÄÇÈÉÊÌÍÒÓÖÔÜàáäâçèéêìíòóöôüß'-\\s]*$",
          message: 'forms.common.validation_messages.not_valid_first_name',
        },
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_first_name',
        },
      ],
      placeholder: 'forms.auth_form.placeholder.firstName',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'lastName',
      validateTrigger: 'onBlur',
      rules: [
        {
          pattern: "^[a-zA-ZÀÁÂÄÇÈÉÊÌÍÒÓÖÔÜàáäâçèéêìíòóöôüß'-\\s]*$",
          message: 'forms.common.validation_messages.not_valid_last_name',
        },
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_last_name',
        },
      ],
      placeholder: 'forms.auth_form.placeholder.lastName',
    },
    {
      tag: 'input',
      type: 'email',
      name: 'email',
      validateTrigger: 'onBlur',
      rules: [
        {
          type: 'email',
          message: 'forms.common.validation_messages.not_valid_email',
        },
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_email',
        },
      ],
      placeholder: 'forms.auth_form.placeholder.email',
    },
    {
      tag: 'input',
      type: 'password',
      name: 'password',
      autoComplete: 'off',
      validateTrigger: 'onBlur',
      rules: [
        {
          pattern: '^[a-zA-Z0-9!@#$%^&*)(+=._-]{6,32}$',
          message: 'forms.common.validation_messages.not_valid_password',
        },
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_password',
        },
      ],
      placeholder: 'forms.auth_form.placeholder.password',
    },
    ...subscribeFragment,
  ],
};
